require("./selectUserDialog.less");

rkcApp.controller("dialogSelectUserController", ['$scope', '$mdDialog', 'PickListUsers', 'toastService', 'editMode', function ($scope, $mdDialog, PickListUsers, toastService, editMode) {
    $scope.editMode = editMode;

    PickListUsers.getPicklistUsers().$promise.then(
        (picklistUsers) => {
            $scope.picklistUsers = picklistUsers;
        }
    );

    $scope.save = function(msg){
        $mdDialog.hide({success:true, id: msg});
    };

    $scope.hide = function() {
        $mdDialog.hide();
    };

    $scope.cancel = function() {
        $mdDialog.cancel();
    };
}]);



/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/distribution/articleLines/selectUserDialog/selectUserDialog.ts
 **/